import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'daccs-form-sales-recon-row',
  templateUrl: './form-sales-recon-row.component.html',
  styleUrls: ['./form-sales-recon-row.component.scss']
})
export class FormSalesReconRowComponent implements OnInit {

  @Input() public arrForm: FormGroup;
  @Input() odd: boolean;

  constructor() {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/views/daily-recon/shifts-recon/components/form-sales-recon/form-sales-recon-row/form-sales-recon-row.component.ts